import { fromZodError } from 'zod-validation-error'
import { useQuery } from '@tanstack/react-query'

import { client } from '../../services/client'
import { makeServerResponseSchema } from '../../utils/schema'
import { oneshopMessageStatsSchema } from './oneshop-message-stats.schema'

const oneshopMessageStatsQueryKeys = {
  all: [{ entity: 'oneshopMessageStats' }] as const,
  oneshopMessageStats: () => [oneshopMessageStatsQueryKeys.all[0]] as const,
}

async function fetchOneShopMessageStats() {
  const response = await client
    .post('functions/getOneShopMessageStats', {
      json: {},
    })
    .json()

  const parsedResponse = makeServerResponseSchema(
    oneshopMessageStatsSchema
  ).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(fromZodError(parsedResponse.error).message)

  return parsedResponse.data.result
}

function useOneShopMessageStats() {
  return useQuery({
    queryFn: fetchOneShopMessageStats,
    queryKey: oneshopMessageStatsQueryKeys.oneshopMessageStats(),
  })
}

export { fetchOneShopMessageStats, useOneShopMessageStats }
